module.exports = "/static/assets/1dd834e80897df09d4e7c0277da2d1a7.gif";